export default __webpack_public_path__ + "static/media/RsProductivity aanalysis.679c2f01.png";